import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  featuresContainer: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
    paddingVertical: 8.4,
  }),
  featureContainer: {
    paddingLeft: 21,
    paddingTop: 12.5,
    paddingBottom: 13.6,
    flexDirection: 'row',
    height: 51,
    alignItems: 'center',
  },
  featureIcon: {
    marginRight: 21.5,
  },
  featureText: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16.6,
  }),
});
